import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import AddIcon from 'ui-library/icons/AddIcon';
import {JSONArray} from 'util/Types';

import jsonSpecToInitialValue from '../jsonSpecToInitialValue';
import {StepConfigUISchema} from '../StepConfigEditorTypes';

interface AddArrayElementIconProps {
  specShape: GetPipelineConfigSpecType<'array'>;
  config: JSONArray | null;
  onChangeConfig: (newConfig: JSONArray) => void;
  elementUiSchema: StepConfigUISchema;
  dataTestAttrsKey: DataTestAttrs['key'];
}

export default function AddArrayElementIcon({
  specShape,
  config,
  onChangeConfig,
  elementUiSchema,
  dataTestAttrsKey,
}: AddArrayElementIconProps): JSX.Element {
  const isButtonDisabled = specShape.maxItems !== undefined && (config ?? []).length === specShape.maxItems;
  return (
    <Tooltip
      isDisabled={!isButtonDisabled}
      text={`Can only have up to ${specShape.maxItems} ${pluralize(
        specShape.maxItems as number,
        'item',
        'items'
      )}`}
    >
      <AddIcon
        disabled={isButtonDisabled}
        onClick={() => {
          const newValue = jsonSpecToInitialValue(specShape.elementSpec, elementUiSchema);
          onChangeConfig(config == null ? [newValue] : [...config, newValue]);
        }}
        dataTestAttrs={{component: 'AddArrayElementIcon', element: 'root', key: dataTestAttrsKey}}
      />
    </Tooltip>
  );
}
